import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../../components/header'
import Footer from '../../components/footer'
import Whatsapp from '../../components/whatsapp'
import './direito-da-sade.css'

const DireitoDaSade = (props) => {
  return (
    <div className="direito-da-sade-container10">
      <Helmet>
        <title>Direito-da-Sade - Adv. Wanderson H Cavalari - Cuiabá</title>
        <meta
          name="description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
        <meta
          property="og:title"
          content="Direito-da-Sade - Adv. Wanderson H Cavalari - Cuiabá"
        />
        <meta
          property="og:description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
      </Helmet>
      <div className="direito-da-sade-container11">
        <main className="direito-da-sade-container12">
          <div className="direito-da-sade-container13">
            <Header rootClassName="headerroot-class-name10"></Header>
            <div className="direito-da-sade-container14">
              <div className="direito-da-sade-frame46">
                <span className="direito-da-sade-text10">ÁREA DE ATUAÇÃO</span>
                <span className="direito-da-sade-text11">Direito da</span>
                <span className="direito-da-sade-text12">Saúde</span>
                <span className="direito-da-sade-text13">
                  A advocacia na área de saúde protege os direitos dos
                  pacientes diante de práticas abusivas das operadoras: negativas
                  de cobertura, reajustes ilegais, cancelamentos indevidos e
                  cobranças excessivas.
                </span>
              </div>
              <div className="direito-da-sade-container15">
                <span className="direito-da-sade-text14">
                  <span>Fale Comigo</span>
                </span>
                <span className="direito-da-sade-text16 Content">
                  Quer saber mais sobre esta área de atuação? Mande-me uma
                  mensagem para introduzirmos esta questão
                </span>
                <iframe
                  src="https://whc-dun.vercel.app/email"
                  scrolling="no"
                  className="direito-da-sade-iframe"
                ></iframe>
              </div>
            </div>
          </div>
          <div className="direito-da-sade-container16">
            <div className="direito-da-sade-container17">
              <div className="direito-da-sade-container18">
                <span className="Head direito-da-sade-text17">
                  Ações contra plano de saúde
                </span>
                <span className="direito-da-sade-text18">
                  Confira abaixo as principais situações em que é possível
                  buscar seus direitos contra o plano de saúde.
                </span>
              </div>
              <div className="direito-da-sade-frame86">
                {/* Reajuste abusivo (TEXT L | IMG R) */}
                <div className="direito-da-sade-container19">
                  <div className="direito-da-sade-container20">
                    <span className="direito-da-sade-text21">
                      Reajuste abusivo de Plano de Saúde
                    </span>
                    <span className="direito-da-sade-text22">
                      Se o contrato de plano de saúde contiver cláusulas
                      abusivas ou ilegais que prejudiquem os direitos do
                      consumidor, é possível entrar com uma ação de revisão de
                      cláusulas contratuais para solicitar a anulação ou
                      modificação dessas cláusulas.
                    </span>
                  </div>
                  <img
                    alt="Mãos analisando apólice de seguro saúde"
                    src="/saude-reajuste-plano.jpg"
                    loading="eager"
                    className="direito-da-sade-image1 section_image"
                  />
                </div>
                {/* Tratamento Negado no geral (IMG L | TEXT R) */}
                <div className="direito-da-sade-container54">
                  <img
                    alt="Itens representando plano de saúde"
                    src="/tratamento%20negado%20(optimized)-300h.webp"
                    loading="eager"
                    className="direito-da-sade-image18 section_image"
                  />
                  <div className="direito-da-sade-container55">
                    <span className="direito-da-sade-text25">
                      Tratamento Negado no geral
                    </span>
                    <span className="direito-da-sade-text26">
                      Quando o plano de saúde se recusa a fornecer cobertura
                      para um tratamento ou procedimento médico prescrito por um
                      médico, o beneficiário pode entrar com uma ação para
                      exigir que a operadora de saúde cumpra com as condições do
                      contrato e forneça o tratamento necessário.
                    </span>
                  </div>
                </div>
                {/* Tratamento de Autismo negado (TEXT L | IMG R) */}
                <div className="direito-da-sade-container21">
                  <div className="direito-da-sade-container22">
                    <span className="direito-da-sade-text27">
                      Tratamento de Autismo negado
                    </span>
                    <span className="direito-da-sade-text28">
                      Quando um plano de saúde nega o tratamento para autismo,
                      o beneficiário pode buscar seus direitos através de
                      várias medidas legais no direito brasileiro. O autismo é
                      reconhecido como uma condição médica que requer tratamento
                      especializado, e negar o acesso a esse tratamento pode
                      configurar uma prática abusiva sujeita a penalidades legais.
                    </span>
                  </div>
                  <img
                    alt="Criança em sessão de terapia para autismo"
                    src="/saude-autismo-tratamento.jpg"
                    loading="eager"
                    className="direito-da-sade-image2 section_image"
                  />
                </div>
                {/* Terapia negada (IMG L | TEXT R) */}
                <div className="direito-da-sade-container56">
                  <img
                    alt="Paciente recebendo fisioterapia"
                    src="/saude-terapia-negada.jpg"
                    loading="eager"
                    className="direito-da-sade-image19 section_image"
                  />
                  <div className="direito-da-sade-container57">
                    <span className="direito-da-sade-text31">
                      Terapia negada
                    </span>
                    <span className="direito-da-sade-text32">
                      Quando uma terapia é negada por um plano de saúde, o
                      beneficiário tem direito a buscar seus direitos através
                      de diversas medidas legais, incluindo ação judicial para
                      obrigar a operadora a custear o tratamento prescrito.
                    </span>
                  </div>
                </div>
                <div className="direito-da-sade-container24">
                  <div className="direito-da-sade-container25">
                    <span className="direito-da-sade-text35">
                      Bariátrica Negada
                    </span>
                    <span className="direito-da-sade-text36">
                      <span>
                        Quando a cirurgia bariátrica é negada por um plano de
                        saúde no Brasil, o paciente tem direito a buscar seus
                        direitos através de várias medidas legais.
                      </span>
                      <br></br>
                      <br></br>
                      <span>
                        - O primeiro passo é solicitar ao plano de saúde uma
                        justificativa formal para a recusa da cirurgia
                        bariátrica. O paciente pode requisitar por escrito os
                        motivos da negativa e as bases legais que embasam a
                        decisão.
                      </span>
                      <br></br>
                      <span>
                        - Ingressar com uma ação judicial contra o plano de
                        saúde é uma medida possível. O objetivo pode ser buscar
                        uma liminar que obrigue a operadora a autorizar e
                        custear a cirurgia bariátrica. O processo judicial visa
                        garantir o acesso à cirurgia enquanto a questão é
                        discutida nos tribunais.
                      </span>
                      <br></br>
                      <br></br>
                      <span>
                        É importante ressaltar que a cirurgia bariátrica é
                        reconhecida como um tratamento eficaz para certos casos
                        de obesidade mórbida e suas comorbidades associadas, e
                        as operadoras de plano de saúde têm o dever de garantir
                        cobertura adequada para os tratamentos necessários.
                        Portanto, é essencial que o paciente esteja ciente de
                        seus direitos e esteja disposto a buscar as medidas
                        legais disponíveis para garantir o acesso à cirurgia
                        bariátrica quando indicada pelo médico especialista.
                      </span>
                      <br></br>
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/bariatric%20surgery%20coverage%20jusvita%20(optimized)-300h.webp"
                    loading="eager"
                    className="direito-da-sade-image3 section_image"
                  />
                </div>
                <div className="direito-da-sade-container26">
                  <div className="direito-da-sade-container27">
                    <span className="direito-da-sade-text47">
                      Cirurgia pós bariátrica negada
                    </span>
                    <span className="direito-da-sade-text48">
                      As cirurgias reparadoras após a bariátrica costumam ser
                      essenciais para corrigir sequelas e complicações. A
                      negativa pode ser revertida judicialmente quando há
                      indicação do médico especialista.
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/plastic%20surgery%20by%20luciano%20schutz%20(optimized)-300h.webp"
                    loading="eager"
                    className="direito-da-sade-image4 section_image"
                  />
                </div>
                {/* Limitação de sessões TEA */}
                <div className="direito-da-sade-container28">
                  <div className="direito-da-sade-container29">
                    <span className="direito-da-sade-text49">
                      Limitação de sessões no tratamento de autismo
                    </span>
                    <span className="direito-da-sade-text50">
                      É abusiva qualquer limitação do número de sessões de
                      terapia para o paciente com TEA. A quantidade e a
                      frequência do tratamento são definidas pelo médico
                      assistente, e não pela operadora, não existe "cota
                      anual" de sessões.
                    </span>
                  </div>
                  <img
                    alt="Criança com cartões de letras em sessão terapêutica"
                    src="/saude-sessoes-tea.jpg"
                    loading="lazy"
                    className="direito-da-sade-image5 section_image"
                  />
                </div>
                {/* Coparticipação TEA */}
                <div className="direito-da-sade-container30">
                  <img
                    alt="Dinheiro ao lado de cartelas de medicamento"
                    src="/saude-coparticipacao.jpg"
                    loading="lazy"
                    className="direito-da-sade-image6 section_image"
                  />
                  <div className="direito-da-sade-container31">
                    <span className="direito-da-sade-text51">
                      Coparticipação abusiva no tratamento de autismo
                    </span>
                    <span className="direito-da-sade-text52">
                      A coparticipação é permitida, mas não pode inviabilizar
                      o tratamento. O total cobrado no mês não pode ultrapassar
                      2x o valor da mensalidade. Cobranças acima disso são
                      abusivas e podem ser limitadas judicialmente, com
                      devolução dos valores pagos a mais.
                    </span>
                  </div>
                </div>
                {/* Negativa de medicamento */}
                <div className="direito-da-sade-container32">
                  <div className="direito-da-sade-container33">
                    <span className="direito-da-sade-text53">
                      Negativa de medicamento
                    </span>
                    <span className="direito-da-sade-text54">
                      A recusa em custear medicamento prescrito, incluindo os
                      de alto custo, de uso oral/domiciliar ou off-label, pode
                      ser revertida na Justiça quando há indicação médica
                      fundamentada, ainda que o remédio não conste do rol da
                      ANS.
                    </span>
                  </div>
                  <img
                    alt="Frascos e comprimidos de medicamento"
                    src="/saude-medicamento.jpg"
                    loading="lazy"
                    className="direito-da-sade-image7 section_image"
                  />
                </div>
                {/* Negativa de internação ou UTI */}
                <div className="direito-da-sade-container34">
                  <img
                    alt="Paciente internado em leito de UTI hospitalar"
                    src="/saude-internacao-uti.jpg"
                    loading="lazy"
                    className="direito-da-sade-image8 section_image"
                  />
                  <div className="direito-da-sade-container35">
                    <span className="direito-da-sade-text55">
                      Negativa de internação ou UTI
                    </span>
                    <span className="direito-da-sade-text56">
                      É abusiva a cláusula que limita o tempo de internação. A
                      operadora não pode restringir os dias de internação ou de
                      UTI determinados pelo médico.
                    </span>
                  </div>
                </div>
                {/* Negativa de home care */}
                <div className="direito-da-sade-container36">
                  <div className="direito-da-sade-container37">
                    <span className="direito-da-sade-text57">
                      Negativa de home care (internação domiciliar)
                    </span>
                    <span className="direito-da-sade-text58">
                      Quando há prescrição médica de atendimento domiciliar,
                      muitas vezes como continuidade da internação, o plano não
                      pode recusar a cobertura. A autorização pode ser obtida
                      judicialmente.
                    </span>
                  </div>
                  <img
                    alt="Idosa sendo atendida em domicílio por profissional de saúde"
                    src="/saude-home-care.jpg"
                    loading="lazy"
                    className="direito-da-sade-image9 section_image"
                  />
                </div>
                {/* OPME */}
                <div className="direito-da-sade-container38">
                  <img
                    alt="Homem com prótese de membro inferior"
                    src="/saude-opme.jpg"
                    loading="lazy"
                    className="direito-da-sade-image10 section_image"
                  />
                  <div className="direito-da-sade-container39">
                    <span className="direito-da-sade-text59">
                      Negativa de próteses e materiais cirúrgicos (OPME)
                    </span>
                    <span className="direito-da-sade-text60">
                      Próteses, órteses, stents e demais materiais ligados ao
                      ato cirúrgico devem ser cobertos. A negativa de
                      fornecimento pode ser revertida judicialmente.
                    </span>
                  </div>
                </div>
                {/* Urgência e emergência */}
                <div className="direito-da-sade-container40">
                  <div className="direito-da-sade-container41">
                    <span className="direito-da-sade-text61">
                      Urgência e emergência durante a carência
                    </span>
                    <span className="direito-da-sade-text62">
                      Mesmo dentro do prazo de carência, o plano é obrigado a
                      cobrir atendimentos de urgência e emergência. A recusa
                      pode gerar, além do custeio, indenização por danos morais.
                    </span>
                  </div>
                  <img
                    alt="Entrada de pronto-socorro hospitalar"
                    src="/saude-urgencia.jpg"
                    loading="lazy"
                    className="direito-da-sade-image11 section_image"
                  />
                </div>
                {/* Doença preexistente */}
                <div className="direito-da-sade-container42">
                  <img
                    alt="Pessoa revisando contrato de plano de saúde"
                    src="/saude-doenca-preexistente.jpg"
                    loading="lazy"
                    className="direito-da-sade-image12 section_image"
                  />
                  <div className="direito-da-sade-container43">
                    <span className="direito-da-sade-text63">
                      Negativa por doença preexistente
                    </span>
                    <span className="direito-da-sade-text64">
                      A operadora não pode recusar cobertura alegando doença
                      preexistente sem comprovar a má-fé do beneficiário e sem
                      ter realizado exame admissional. A negativa indevida pode
                      ser contestada.
                    </span>
                  </div>
                </div>
                {/* Cancelamento indevido */}
                <div className="direito-da-sade-container44">
                  <div className="direito-da-sade-container45">
                    <span className="direito-da-sade-text65">
                      Cancelamento ou rescisão indevida do contrato
                    </span>
                    <span className="direito-da-sade-text66">
                      A rescisão unilateral e imotivada de plano individual é
                      vedada, e o plano coletivo não pode ser cancelado durante
                      tratamento em curso. Cabe ação para manter o contrato e
                      reparar prejuízos.
                    </span>
                  </div>
                  <img
                    alt="Documento de contrato de plano de saúde"
                    src="/saude-cancelamento.jpg"
                    loading="lazy"
                    className="direito-da-sade-image13 section_image"
                  />
                </div>
                {/* Aposentados e demitidos */}
                <div className="direito-da-sade-container46">
                  <img
                    alt="Paciente idoso sendo atendido por médico"
                    src="/saude-aposentados-plano.jpg"
                    loading="lazy"
                    className="direito-da-sade-image14 section_image"
                  />
                  <div className="direito-da-sade-container47">
                    <span className="direito-da-sade-text67">
                      Manutenção do plano para aposentados e demitidos
                    </span>
                    <span className="direito-da-sade-text68">
                      O empregado aposentado ou demitido sem justa causa, que
                      contribuía para o plano, tem direito de permanecer nele
                      nas condições da lei (arts. 30 e 31 da Lei 9.656/98). A
                      negativa pode ser revertida.
                    </span>
                  </div>
                </div>
                {/* Descredenciamento */}
                <div className="direito-da-sade-container48">
                  <div className="direito-da-sade-container49">
                    <span className="direito-da-sade-text69">
                      Descredenciamento de hospital ou médico sem aviso
                    </span>
                    <span className="direito-da-sade-text70">
                      O descredenciamento só é válido com comunicação prévia ao
                      beneficiário e substituição por prestador equivalente,
                      especialmente durante tratamento.
                    </span>
                  </div>
                  <img
                    alt="Fachada de hospital universitário descredenciado"
                    src="/saude-descredenciamento.jpg"
                    loading="lazy"
                    className="direito-da-sade-image15 section_image"
                  />
                </div>
                {/* Reembolso */}
                <div className="direito-da-sade-container50">
                  <img
                    alt="Formulários fiscais com moedas douradas representando reembolso"
                    src="/saude-reembolso.jpg"
                    loading="lazy"
                    className="direito-da-sade-image16 section_image"
                  />
                  <div className="direito-da-sade-container51">
                    <span className="direito-da-sade-text71">
                      Negativa ou pagamento a menor de reembolso
                    </span>
                    <span className="direito-da-sade-text72">
                      Quando há direito a reembolso, sobretudo em urgência sem
                      rede credenciada, e o plano nega ou paga menos do que o
                      devido, é possível exigir judicialmente o valor integral.
                    </span>
                  </div>
                </div>
                {/* Danos morais */}
                <div className="direito-da-sade-container52">
                  <div className="direito-da-sade-container53">
                    <span className="direito-da-sade-text73">
                      Danos morais por negativa indevida
                    </span>
                    <span className="direito-da-sade-text74">
                      A recusa injustificada de cobertura, principalmente em
                      urgência ou quando agrava o estado de saúde, pode gerar
                      direito a indenização por danos morais, além do
                      cumprimento da obrigação pelo plano.
                    </span>
                  </div>
                  <img
                    alt="Martelo de juiz ao lado de documentos jurídicos"
                    src="/saude-danos-morais.jpg"
                    loading="lazy"
                    className="direito-da-sade-image17 section_image"
                  />
                </div>
              </div>
            </div>
          </div>
          <Footer rootClassName="footerroot-class-name4"></Footer>
          <Whatsapp></Whatsapp>
        </main>
      </div>
    </div>
  )
}

export default DireitoDaSade
